<template>
  <div>

    <a-skip-to-content />
    <s-busy-global />
    <s-modal />
    <s-header />
    <s-notification-center />

    <s-main>
      <router-view />
    </s-main>

    <s-footer />

  </div>
</template>

<script>
import SBusyGlobal from '@/components/singletons/SBusyGlobal'
import SFooter from '@/components/singletons/SFooter'
import SHeader from '@/components/singletons/SHeader'
import SMain from '@/components/singletons/SMain'
import SModal from '@/components/singletons/SModal'
import SNotificationCenter from '@/components/singletons/SNotificationCenter'
import ASkipToContent from '@/components/atoms/ASkipToContent'

export default {
  name: 'App',

  components: {
    SBusyGlobal,
    SFooter,
    SHeader,
    SMain,
    SModal,
    SNotificationCenter,
    ASkipToContent
  }
}
</script>

<style src="normalize.css"></style>

<style src="./css/scaffolding.css"></style>
<style src="./css/table.css"></style>
<style src="./css/transitions.css"></style>
